import { render, staticRenderFns } from "./create-time-wishing-pool.vue?vue&type=template&id=654a67cb&scoped=true"
import script from "./create-time-wishing-pool.vue?vue&type=script&lang=js"
export * from "./create-time-wishing-pool.vue?vue&type=script&lang=js"
import style0 from "./create-time-wishing-pool.vue?vue&type=style&index=0&id=654a67cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a67cb",
  null
  
)

export default component.exports